<template>
    <div>
        <h5 class="mb-3 font-weight-bold">Payouts</h5>
        <div class="card shadow-sm border-0" v-if="payout_requests">
            <div class="card-body">
                
                <div>
                    <!-- <table class="table table-responsive">
                        <thead>
                            <tr class="">
                                <th scope="col">#</th>
                                <th scope="col"></th>
                                <th scope="col"> </th>
                                <th scope="col" style="width: 500px;"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr>
                                <td class="" >
                                    <div class="avatar-container d-flex align-items-center">
                                        <div class="avatar-container">
                                            <img src="@/assets/avatar-purple.png" class="avatar" alt="avatar" style="height:40px; width: 40px;">
                                        </div>
                                    </div>
                                </td>
                                <td class="" style="width: 300px">
                                    <div class="d-flex flex-wrap">
                                        <p class="my-0 mr-3 h6">
                                            
                                        </p>

                                    </div>
                                </td>
                                <td class="" style="width: 300px"> 
                                    <p class="my-0 h6 text-success font-weight-bold"> &#8358;</p>
                                </td>

                            </tr>

                        </tbody>
                    </table> -->
                </div>
            </div>
        </div>

        <div class="card border-0 shadow-sm" style="min-height:80vh" v-else>
            <div class="card-body d-flex justify-content-center align-items-center">
                <div class="">
                    <h6>
                        <span class="fa fa-credit-card"></span> No Payout Requests
                    </h6>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            payout_requests: null
        }
    },
    computed: {
        userProfile() {
            return this.$store.getters.userProfile;
        }
    },
    created() {
        // this.$store.dispatch('getUserProfile', this)
        this.getUserPayoutRequests()
    },
    methods: {
        async getUserPayoutRequests() {

            try {
                const requests = await axios.post(
                    `/pool/payout_request/user/${this.userProfile.account_id}`, { account_id: this.userProfile.account_id }
                );

                if (requests.status == 200) {

                    const { message } = requests.data;

                    if (message instanceof Object) {
                        this.payout_requests = message;
                    }
                    if (message instanceof String) {
                        this.payout_requests = null;
                    }
                }

                console.log(requests);
                
            } catch (error) {
                
            }
        }
    }

}
</script>

<style>

</style>